import { render, staticRenderFns } from "./GKButton.vue?vue&type=template&id=5169500f&scoped=true&"
import script from "./GKButton.vue?vue&type=script&lang=js&"
export * from "./GKButton.vue?vue&type=script&lang=js&"
import style0 from "./GKButton.vue?vue&type=style&index=0&id=5169500f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169500f",
  null
  
)

export default component.exports